module.exports = __webpack_public_path__ + "img/4N.98532c37.png";